import { assign, createMachine } from "xstate";

import { BrandImport, BrandImportRst } from "../types/brand";

interface BrandImportContext {
  brands: BrandImport[];
  rst: BrandImportRst[];
}

const assignBrands = assign({
  brands: (context, event: any) => event.brands,
});

const assignRst = assign({
  rst: (context, event: any) => event.rst,
});

export const brandImportMachine = createMachine(
  {
    id: "BrandImport",
    initial: "init",
    predictableActionArguments: true,
    schema: {
      context: {} as BrandImportContext,
    },
    context: {
      brands: null as any,
      rst: null as any,
    },
    states: {
      init: {
        on: {
          SELECT_FILE: {
            target: "list",
            actions: ["assignBrands"],
          },
        },
      },
      list: {
        on: {
          UPLOAD: {
            target: "uploading",
          },
          BACK: {
            target: "init",
          },
        },
      },
      uploading: {
        on: {
          COMPLETED: {
            target: "completed",
            actions: ["assignRst"],
          },
        },
      },
      completed: {},
    },
  },
  {
    actions: { assignBrands, assignRst },
  }
);
